import _ from 'lodash';
import { FieldTypes } from '../types/carrierQuestionnaire/fieldTypes';
import { SubsectionVariants } from '../types/carrierQuestionnaire/subsectionVariant';
export var SubmissionSubsectionLayout;
(function (SubmissionSubsectionLayout) {
    SubmissionSubsectionLayout["flow"] = "flow";
})(SubmissionSubsectionLayout || (SubmissionSubsectionLayout = {}));
export function isTextFieldType(type) {
    const textFieldTypes = [
        FieldTypes.input,
        FieldTypes.number,
        FieldTypes.money,
        FieldTypes.phone,
        FieldTypes.textarea,
        FieldTypes.date,
        FieldTypes.yearMonth,
    ];
    return textFieldTypes.includes(type);
}
export function isField(field) {
    return !!field.type;
}
export function isOptionField(field) {
    return (!_.isEmpty(field.options) &&
        (field.type === FieldTypes.radio || field.type === FieldTypes.checkboxGroup || field.type === FieldTypes.dropdown));
}
export function isOptionFieldFromApplicationContext(field) {
    return !!field.optionsFromApplicationContext;
}
export function isDropdownOptionField(field) {
    return !_.isEmpty(field.options) && field.type === FieldTypes.dropdown;
}
export function isDynamicOptionField(field) {
    return !!field.dynamicOptions;
}
export function isReadOnlyField(field) {
    return field.readOnly === true;
}
export function isAgreeField(field) {
    return field.type === FieldTypes.agree;
}
export function isButtonField(field) {
    return field.type === FieldTypes.button;
}
export function isPlaceholderField(field) {
    return !!field.placeholder;
}
export function isBlockingSubsection(subsection) {
    return !!subsection.blockedIf;
}
export function isSectionGroupRepeatable(sectionGroup) {
    return !!sectionGroup.options?.repeatable;
}
export function isFieldGroup(fieldGroup) {
    return !!fieldGroup.fields;
}
export function isFieldGroupRepeatable(fieldGroup) {
    return isFieldGroup(fieldGroup) && !!fieldGroup.options?.repeatable;
}
export function isQuoterSubsection(subsection) {
    return subsection.variant === SubsectionVariants.quoter;
}
export function isRepeatableOptionsWithLimits(repeatableOptions) {
    return repeatableOptions.minRepetitions !== undefined;
}
export function isRepeatableOptionsBasedOnCollection(repeatableOptions) {
    return !!repeatableOptions.expandToCollectionLength;
}
export var FieldValueTypes;
(function (FieldValueTypes) {
    FieldValueTypes["string"] = "string";
    FieldValueTypes["boolean"] = "boolean";
    FieldValueTypes["array"] = "array";
})(FieldValueTypes || (FieldValueTypes = {}));
// NOTE: Please update the README.md in shared/questionnaire-engine if this is modified.
export var InfoVariants;
(function (InfoVariants) {
    InfoVariants["warning"] = "warning";
    InfoVariants["error"] = "error";
    InfoVariants["success"] = "success";
    InfoVariants["info"] = "info";
    InfoVariants["paragraph"] = "paragraph";
})(InfoVariants || (InfoVariants = {}));
// readOnlyFieldsTypes refer to FieldTypes that can only be used as readOnly field.
// readOnly property needs to be set to true on the field when any of these FieldTypes is specified.
export const readOnlyFieldTypes = [FieldTypes.information, FieldTypes.currencyCard, FieldTypes.signature];
// "supportedReadOnlyFieldTypes" refer to FieldTypes that support the readOnly property set to true.
// For example, FieldTypes.input is allowed to be displayed as a readOnly field but also as a regular field and
// the field generator will display the input field as disabled when readOnly is set to true.
export const supportedReadOnlyFieldTypes = [...readOnlyFieldTypes, FieldTypes.input];
